export default "__VITE_ASSET__B_9j3PoV__"